import React from 'react';
import './AboutMe.css'; // Create a CSS file for styling


const skills = [
    { label: 'JAVA', percentage: '80%' },
    { label: 'Python', percentage: '99%' },
    { label: 'C', percentage: '70%' },
    { label: 'C++', percentage: '68%' },
    { label: 'HTML', percentage: '97%' },
    { label: 'JS', percentage: '91%' },
    { label: 'CSS', percentage: '90%' },
    { label: 'React.js', percentage: '75%' },
    { label: 'Node.js', percentage: '75%' },
    { label: 'LLM', percentage: '95%' },
    { label: 'Laravel', percentage: '60%' },
    { label: 'PHP', percentage: '30%' },
    { label: 'MongoDB', percentage: '89%' },
    { label: 'MySQL', percentage: '80%' },
    { label: 'GitHub', percentage: '83%' },
    { label: 'GCP', percentage: '50%' },
    { label: 'Keras', percentage: '50%' },
    { label: 'Tensorflow', percentage: '60%' },
    { label: 'Pandas', percentage: '94%' },];


const hobbies = [
    { label: 'LinkedIn', link: 'https://www.linkedin.com/in/rishabh--tripathi/', color: '#0a66c2' },
    { label: 'GitHub', link: 'https://github.com/Rishabh-Tripathi1', color: '#f3563e' },
    { label: 'Instagram', link: 'https://www.instagram.com/dalazzyyrishi/', color: '#f01f48' },
    { label: 'Medium', link: 'https://medium.com/@rishabhtripathi1', color: '#949494' },
];

const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
};

const buttonContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap', // Allow flex items to wrap to the next line
    justifyContent: 'center', // Center the items horizontally
};


const AboutUs = () => {
    return (
        <div className="about-us-container">
            <div className="skill-container">
                <div>
                    <h2 className='skills'>Tech I know</h2>
                    <div style={buttonContainerStyle}>
                        {skills.map((skill, index) => (
                            <a
                                key={index}
                                href={skill.link}
                                className='button'
                                data-percentage={skill.percentage}
                                style={{ '--percentage': skill.percentage }}
                            >
                                {skill.label}
                            </a>
                        ))}
                    </div>
                </div>
                <div>
                    <h2 className='hobbies'>Socials</h2>
                    <div style={containerStyle}>
                        {hobbies.map((hobby, index) => (
                            <a
                                key={index}
                                href={hobby.link}
                                style={{ '--colo': hobby.color }}
                                className='handle'
                            >
                                {hobby.label}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            <div className="text-container">
                <div className='fb'>
                    <h2 className='title'>About Me<span className="dot">.</span></h2>
                    <div className='line'></div>
                </div>
                <div className="scrollable-text">
                    {<p>👋 Hi there! I'm a leader who values solitude but thrives on collaboration. With a passion for learning, I delve into <b>AI/ML</b> and tackle challenges in <b>Web Development</b>. I enjoy hackathons and pioneering new concepts with teams.
                        <br></br>
                        <br></br>
                        Outside work, I find inspiration in reading, nature walks, and video editing. Balancing work and personal interests is key to success and fulfillment in life.</p>}
                </div>
            </div>
        </div >
    );
};

export default AboutUs;
